<template>
  <QCarousel
    v-model="slide"
    animated
    navigation
    swipeable
    autoplay
    infinite
    :padding="false"
    navigation-position="bottom"
    transition-prev="slide-right"
    transition-next="slide-left"
    class="w-full"
    @mouseenter="autoplay = false"
    @mouseleave="autoplay = true"
  >
    <template #navigation-icon />
    <QCarouselSlide
      v-for="(banner,index) in banners"
      :name="index"
      class="!p-0"
    >
      <template #default>
        <div
          class="w-full h-full bg-center bg-cover"
          :style="{'background-image': `url(${banner})`}"
        />
      </template>
    </QCarouselSlide>
  </QCarousel>
</template>

<script setup>
import { computed, ref } from 'vue'
import Banner1 from '@/assets/home/banner-1.png'
import BannerMobile1 from '@/assets/home/banner-mobile-1.png'
import { useQuasar } from 'quasar'

const $q = useQuasar()
const banners = computed(() => {
  if ($q.screen.gt.sm) {
    return [
      Banner1,
    ]
  }
  return [
    BannerMobile1,
  ]
})
const slide = ref(0)
const autoplay = ref(true)
</script>

<style>
.q-carousel__navigation--bottom {
  @apply bottom-1 md:bottom-4;
}
</style>
